import { BlockTitle } from "@blocks/Blocks";

import AwardCategoriesSection from "./AwardCategoriesSection";
import AwardDurationSection from "./AwardDurationSection";
import ParticipationsSection from "./ParticipationsSection";
import PastParticipantsSection from "./PastParticipantsSection";
import ResultsSection from "./ResultsSection";

/**
 * Component to render About section for FAQ Page
 */
const AboutSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="About the Awards"
        rootClassName="bg-gray-150 lg:text-xl font-medium pb-6 pt-3 pl-4 font-poppins"
      />

      <AwardDurationSection />

      <ParticipationsSection />

      <PastParticipantsSection />

      <AwardCategoriesSection />

      <ResultsSection />
    </>
  );
};

export default AboutSection;
